import arenas from '../../../assets/arenas/arenas.json' with { type: 'json' };
import type { ArenaGeometry } from './types';

export interface ArenaDef extends ArenaGeometry {
  id: string;
  image: string;
  pixelSize: readonly [number, number];
}

type RawArena = {
  image: string;
  pixelSize: number[];
  center: number[];
  apothems: number[];
};

/** All arenas from assets/arenas/arenas.json (the octagon geometry the sim needs). */
export const ARENAS: Readonly<Record<string, ArenaDef>> = Object.fromEntries(
  Object.entries(arenas as Record<string, RawArena>).map(([id, a]) => [
    id,
    {
      id,
      image: a.image,
      pixelSize: [a.pixelSize[0] ?? 0, a.pixelSize[1] ?? 0] as const,
      center: [a.center[0] ?? 0, a.center[1] ?? 0] as const,
      apothems: [...a.apothems],
    },
  ]),
);

export function arenaById(id: string): ArenaDef {
  const a = ARENAS[id];
  if (!a) throw new Error(`Unknown arena ${id}`);
  return a;
}
